/* eslint-disable jsx-a11y/alt-text */
import { Navigate } from "react-router-dom";
import { useAuth } from "../providers/AuthProvider";
import styles from "../styles/components/DeleteButton.module.css";
import { useEffect, useState } from "react";
import useApi from "../hooks/useApi";
import trash from "../images/trash.png";

const DeleteButton = ({ onDelete }) => {
  const [confirm, setConfirm] = useState(false);

  const handleDeleteWithConfirmation = (e) => {
    e.stopPropagation();
    setConfirm(true);
  };

  const handleAccept = (e) => {
    e.stopPropagation();
    onDelete();
  };

  const handleCancel = () => setConfirm(false);

  return (
    <div>
      {confirm && (
        <div className={styles.confirm}>
          <button onClick={handleAccept}>yes</button>
          <button onClick={handleCancel}>no</button>
        </div>
      )}
      <button
        onClick={handleDeleteWithConfirmation}
        className={styles.trashButton}
      >
        <img className={styles.trashIcon} src={trash} />
      </button>
    </div>
  );
};

export default DeleteButton;
